/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import PropTypes from 'prop-types'

import { Area } from '@netbasequid/chart'
import { useDisplayTheme } from '../../../hooks/useUiState'

const AreaChart = ({
  stacking,
  timeUnit,
  xAxisUnit,
  yAxisTitle,
  data,
  colorSettings,
  seriesHeader
}) => {
  const theme = useDisplayTheme()

  return (
    <Area
      mode={theme}
      stacking={stacking}
      timeUnit={timeUnit}
      xAxisUnit={xAxisUnit}
      yAxisTitle={yAxisTitle}
      data={data}
      colorSettings={colorSettings}
      seriesHeader={seriesHeader}
    />
  )
}

AreaChart.defaultProps = {
  stacking: '',
  timeUnit: '',
  xAxisUnit: 'datetime',
  yAxisTitle: '',
  colorSettings: {},
  seriesHeader: ''
}
AreaChart.propTypes = {
  stacking: PropTypes.string,
  timeUnit: PropTypes.string,
  xAxisUnit: PropTypes.string,
  yAxisTitle: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          x: PropTypes.number,
          y: PropTypes.number
        })
      )
    })
  ).isRequired,
  colorSettings: PropTypes.objectOf(PropTypes.string),
  seriesHeader: PropTypes.string
}

export default AreaChart
